<template>
  <div>
    <div class="inline-form-group">
      <el-col :span="13">
        <dads-select
          v-model="meId"
          placeholder="Select a greeting"
          filterable
          clearable
        >
          <template slot="prefix">Select a greeting</template>
          <el-option
            v-for="item in mediafileOptions"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          />
        </dads-select>
      </el-col>
    </div>

    <div v-if="meId" class="flex align-center">
      <el-button
        class="mr-5"
        type="primary"
        circle
        v-loading="playPending"
        :icon="isPlaying ? 'mdi mdi-pause' : 'mdi mdi-play'"
        :disabled="playPending"
        @click="isPlaying ? pause() : play()"
      />
      <el-tooltip placement="top" content="Download Greeting">
        <el-button
          v-loading="downloadPending"
          :disabled="downloadPending"
          circle
          icon="el-icon-download"
          @click="download"
        />
      </el-tooltip>

      <div class="ml-80">
        <el-tooltip placement="top" content="Save as current">
          <el-button
            type="primary"
            circle
            icon="mdi mdi-content-save"
            v-loading="saveProcessing"
            :disabled="saveProcessing"
            @click="save"
          />
        </el-tooltip>
      </div>
    </div>
  </div>
</template>

<script>
import feathersClient from "@/feathers/feathers-client";
import DadsSelect from "@/components/select";

export default {
  name: "vmMediafile",

  props: {
    mediafileOptions: { required: true },
    isPlaying: { required: true },
    saveProcessing: { required: true },
    saveSucceded: { required: true },
  },

  components: { DadsSelect },

  data() {
    return {
      meId: null,

      blob: null,
      downloadPending: false,
      playPending: false,
    };
  },

  watch: {
    meId() {
      this.blob = null;
      this.pause();
    },

    saveSucceded(saveSucceded) {
      if (saveSucceded) {
        this.meId = null;
      }
    },
  },

  methods: {
    async fetchFile() {
      if (this.blob || !this.meId) {
        return;
      }

      try {
        const res = await feathersClient.service("mediafiles").get(this.meId);

        if (!res || !res.recording) {
          this.$notify({
            title: "Not Found",
            message: "File Not Found.",
            type: "warning",
          });
          return;
        }

        this.blob = res.recording;
      } catch (err) {
        console.log({ err });
      }
    },

    async play() {
      this.playPending = true;
      await this.fetchFile();
      this.playPending = false;

      if (this.blob) {
        this.$emit("play", { type: "choice", blob: this.blob });
      }
    },

    pause() {
      this.$emit("pause");
    },

    async download() {
      this.downloadPending = true;
      await this.fetchFile();

      if (this.blob) {
        const link = document.createElement("a");
        link.href = this.blob;
        link.click();
      }

      this.downloadPending = false;
    },

    save() {
      this.$emit("save", { type: "existing", meId: this.meId });
    },
  },
};
</script>

<style lang="scss" scoped>
.el-button {
  margin-left: 0;
}
</style>
